// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-comp{max-width:235px}.app-icon{overflow:hidden;border-radius:12px;width:56px;height:56px;margin:0 auto 15px;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:hsla(0,0%,80%,.15)}.app-icon img{max-width:100%;-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
